export enum PatientGoalMeasurementStatusEnum {
    ALL = 'all',
    ACTIVE = 'active',
    INACTIVE = 'inactive'
}
